import { i18nextConfig } from './i18nextConfig';
import i18next from 'i18next';
import Locize from 'i18next-locize-backend';
import { initReactI18next } from 'react-i18next';

declare module 'i18next' {
    export interface CustomTypeOptions {
        defaultNS: 'locize';
        // fallbackNS: 'json';
        returnNull: false;
        keySeparator: '::';
        resources: {
            /**
             * Typing the "locize" namespace from the translation defaults file to ensure we always have a default
             */
            // eslint-disable-next-line @typescript-eslint/consistent-type-imports -- dynamic import
            locize: typeof import('../../../../../translation.en.json');
            // eslint-disable-next-line @typescript-eslint/consistent-type-imports -- dynamic import
            json: typeof import('../../../../../translation.en.json');
        };
        strictKeyChecks: true;
    }
}

i18next.use(Locize).use(initReactI18next).init(i18nextConfig);

i18next.services.formatter?.add('uppercase', (value: string) => {
    return value.toLocaleUpperCase();
});
i18next.services.formatter?.add('titlecase', (value: string) => {
    return value
        .split(' ')
        .map((word) => `${word.charAt(0).toLocaleUpperCase()}${word.slice(1)}`)
        .join(' ');
});
